(ns frontend.view.nev.zap-vault.view
  (:require [common.localization :as loc]
            [frontend.page-components.default-page-layout :as default-page-layout]
            [frontend.page-components.zap-toolbar :as zap-toolbar]
            [frontend.routing :as routing]
            [frontend.state.current-session :as session]
            [frontend.view.entity-viewers.scope :as scope]
            [frontend.view.nev.zap-vault.event :as event]
            [frontend.view.nev.zap-vault.model :as model]
            [frontend.view.nev.zap-vault.sub :as sub]
            [frontend.view.nev.zap-vault.tab-analytics :as tab-analytics]
            [frontend.view.nev.zap-vault.tab-configuration :as tab-configuration]
            [frontend.view.nev.zap-vault.tab-disclaimer :as tab-disclaimer]
            [frontend.view.nev.zap-vault.tab-documents :as tab-documents]
            [frontend.view.nev.zap-vault.tab-permissions :as tab-permissions]
            [re-frame.core :as rf]
            [ui.components.link.view :as link]
            [ui.util :as uu]))



(defn view
  []
  (let [active-tab @(rf/subscribe [::sub/active-tab])
        config @(rf/subscribe [::sub/config-with-updates])
        tab-ctx {:active-tab    active-tab
                 :tab-event-vec [::event/set-active-tab]}]
    [:div
     {:class "grid grid-cols-1 md:grid-cols-10 flex flex-row"}
     [:div
      {:class "max-w-full md:col-span-2 sticky mb-6 top-0 flex md:flex-col gap-3 md:gap-1 md:gap-4 text-base-light-text font-semibold *:truncate p-4"}
      [link/side-link-tab (assoc tab-ctx :tab-key model/tab-documents
                                         :label (loc/tr :documents))]
      [link/side-link-tab (assoc tab-ctx :tab-key model/tab-analytics
                                         :label (loc/tr :analytics))]
      [link/side-link-tab (assoc tab-ctx :tab-key model/tab-configuration
                                         :label (loc/tr :configuration))]
      [link/side-link-tab (assoc tab-ctx :tab-key model/tab-permissions
                                         :label (loc/tr :permissions))]


      (when-not (false? (:vault-config/allow-disclaimer-modification? config))
        [link/side-link-tab (assoc tab-ctx :tab-key model/tab-disclaimer
                                           :label (loc/tr :disclaimer))])]
     [:div
      {:class "md:col-span-8 flex flex-col"}
      (condp = active-tab
        model/tab-documents [tab-documents/view]
        model/tab-analytics [tab-analytics/view]
        model/tab-configuration [tab-configuration/view]
        model/tab-disclaimer [tab-disclaimer/view]
        model/tab-permissions [tab-permissions/view]
        (pr-str active-tab))]]))

(defn toolbar
  []
  (let [vault @(rf/subscribe [::sub/vault])
        archived? (true? (:common/archived? vault))]
    [zap-toolbar/nev-toolbar
     {:state   nil
      :label   (partial zap-toolbar/toolbar-back
                        [:zap-vaults-grid]
                        (loc/tr :navbar-item/zap-vault))
      :actions [(zap-toolbar/dropdown-button
                  {:icon            :fa-copy
                   :on-select       (fn [_]
                                      (rf/dispatch [::event/copy-link-to-clipboard]))
                   :primary-button? true
                   :toolbar-button? true
                   :ord             1
                   :label           (loc/tr :copy-link-to-clipboard)})
                (zap-toolbar/dropdown-toggle-item
                  {:id           :zap-vault-active-toggle
                   :icon         :fa-eye
                   :ord          -2
                   :label        (if archived?
                                   (loc/tr :unarchive)
                                   (loc/tr :archive))
                   :custom-item? true
                   :value        [:div
                                  {:class "flex justify-between gap-2 text-sm"}
                                  [:div
                                   {:class "flex items-center gap-2"}
                                   [:i
                                    {:class (uu/cm "fal" (if archived?
                                                           "fa-play"
                                                           "fa-pause"))}]
                                   [:span (loc/tr (if archived?
                                                    :unarchive
                                                    :archive))]]]
                   :on-select    (fn [_]
                                   (rf/dispatch [::event/toggle-archived vault]))})]}]))

(defmethod routing/render-view :entity.type/zap-vault
  [{:keys [route-params _view-params]}]
  (js/console.log "DEBUG ROUTING ZAP_VAULT : " route-params " << " _view-params)
  (let [vault-id (-> route-params
                     :id
                     js/parseInt)
        tab (-> route-params
                :tab
                (keyword))]
    (rf/dispatch [::event/init vault-id tab])
    [default-page-layout/view
     ;;the key change forces re-rendering of the component (and its child components)
     ^{:key (str "zap-vault-viewer-id-" vault-id)}
     ;; The Documents tab reads the attachments of the vault from the session. A
     ;; new-grid account does not get them from the sync, so the page owns a scope
     ;; on the vault.
     [scope/host
      {:entity-id   vault-id
       :instance-id :nev-zap-vault
       :enabled?    (session/new-grid-2023?)}
      [toolbar]
      [view]]]))
